/// <references types="houdini-svelte">

/** @type {import('houdini').ConfigFile} */
const config = {
	schemaPath: './../bff/schema.gql',
	plugins: {
		'houdini-svelte': {},
	},
	defaultFragmentMasking: 'disable',
	types: {
		ItineraryFavorite: {
			keys: ['timestamp'],
		},
	},
};

export default config;
